@import (reference) '../../../../../../../constants/spacing.module.less';

.discount-badge {
  display: inline-flex;
  padding: @space-4 @space-8;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid var(--purple-8D30F7);
  background: var(--purple-F6F2FF);
  color: var(--purple-8D30F7);
  white-space: nowrap;
}

.coupon-discount-badge {
  display: inline-flex;
  padding: @space-4 @space-8;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid var(--blue-1D5AD8);
  background: var(--blue-EDF6FF);
  color: var(--blue-1D5AD8);
  white-space: nowrap;
}
